import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type BuyTwilioNumberPayload = {
  dealer_id: number;
};

type BuyTwilioNumberResponse = {
  phone_number: string;
};

export const useBuyTwilioNumberMutation = () =>
  useTypedMutation<BuyTwilioNumberPayload, BuyTwilioNumberResponse>({
    mutationFn: async payload => (await ApiInstance.post("/sub_accounts/buy_number", payload, ENV.twilioBaseURL)).data,
    onSuccess: (payload, response) => {
      const dealerUpdate = { twilio_phone_number: response.phone_number, is_twilio_sub_account_managed: true };

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...dealerUpdate })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({ ...selectedDealer, ...dealerUpdate });
    }
  });
